/**
 * Stable CSS class names for E2E — User order details layout & customer/order price cards.
 */

export const CIC = {
    loadingGrid: 'order-detail-customer-information-card__loading-grid',
    loadingInner: 'order-detail-customer-information-card__loading-inner',
    root: 'order-detail-customer-information-card',
    headerCard: 'order-detail-customer-information-card__header-card',
    headerTitleRow: 'order-detail-customer-information-card__header-title-row',
    headerIcon: 'order-detail-customer-information-card__header-icon',
    title: 'order-detail-customer-information-card__title',
    blacklistInfoTrigger: 'order-detail-customer-information-card-input--icon-blacklist-info',
    divider: 'order-detail-customer-information-card__divider',
    bodyCard: 'order-detail-customer-information-card__body-card',
    bodyContent: 'order-detail-customer-information-card__body-content',
    nameRow: 'order-detail-customer-information-card__name-row',
    phoneRow: 'order-detail-customer-information-card__phone-row',
    emailRow: 'order-detail-customer-information-card__email-row',
    emailText: 'order-detail-customer-information-card__email-text',
    linkCustomerManagement: 'order-detail-customer-information-card-input--link-customer-management',
    lockedGrid: 'order-detail-customer-information-card__locked-grid',
    lockedInner: 'order-detail-customer-information-card__locked-inner',
    lockedIcon: 'order-detail-customer-information-card__locked-icon',
    lockedBlurContent: 'order-detail-customer-information-card__locked-blur-content',
} as const;

export const OPC = {
    dialogDiscountPaper: 'order-detail-order-price-card__dialog-discounts-paper',
    root: 'order-detail-order-price-card',
    headerCard: 'order-detail-order-price-card__header-card',
    headerIcon: 'order-detail-order-price-card__header-icon',
    title: 'order-detail-order-price-card__title',
    divider: 'order-detail-order-price-card__divider',
    bodyCard: 'order-detail-order-price-card__body-card',
    bodyContent: 'order-detail-order-price-card__body-content',
    scrollArea: 'order-detail-order-price-card__scroll-area',
    rowPrice: 'order-detail-order-price-card__row-price',
    rowDiscount: 'order-detail-order-price-card__row-discount',
    inputButtonDiscountDetails: 'order-detail-order-price-card-input--button-discount-details',
    rowSubTotal: 'order-detail-order-price-card__row-subtotal',
    rowShippingFee: 'order-detail-order-price-card__row-shipping-fee',
    cargoCampaignWrap: 'order-detail-order-price-card__cargo-campaign-wrap',
    rowAdditionalFee: 'order-detail-order-price-card__row-additional-fee',
    rowTotalAmount: 'order-detail-order-price-card__row-total-amount',
    rowCompletedRefund: 'order-detail-order-price-card__row-completed-refund',
    rowPendingRefund: 'order-detail-order-price-card__row-pending-refund',
    lockedGrid: 'order-detail-order-price-card__locked-grid',
    lockedInner: 'order-detail-order-price-card__locked-inner',
    lockedIcon: 'order-detail-order-price-card__locked-icon',
    lockedBlurContent: 'order-detail-order-price-card__locked-blur-content',
} as const;

export const UODC = {
    layout: 'order-detail-user-order-details__layout',
    sectionOrderInformation: 'order-detail-user-order-details__section-order-information',
    sectionCustomerInformation: 'order-detail-user-order-details__section-customer-information',
    sectionOrderPrice: 'order-detail-user-order-details__section-order-price',
    sectionAddressInformation: 'order-detail-user-order-details__section-address-information',
} as const;

export const uodCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
